/* Progressive enhancement: navigation and FAQ remain usable without JavaScript. */
(() => {
  const menuSelector = '.mh-mobile-menu';
  document.addEventListener('click', (event) => {
    document.querySelectorAll(`${menuSelector}[open]`).forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${menuSelector}[open]`).forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
})();
